<template lang="pug">
form#manage-budget-form
  fieldset
    BudgetsForm(
      ref="budgetsForm"
      :organization="organization"
      :duration-format="durationFormat"
      :disabled="!canManageBudget"
      :budget-state="budgetState"
      :has-budget="!!client.has_budget"
      @change-budget-field="handleChangeBudgetField"
      @clear-budget="handleClearBudget"
    )
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BudgetsForm from '../budgets/BudgetsForm.vue';

export default {
  name: 'ClientDialogTabBudgets',
  components: { BudgetsForm },
  computed: {
    ...mapState(['client', 'budget', 'organization']),
    ...mapGetters(['durationFormat', 'canManageBudget']),
    budgetState() {
      return this.client.budget || {};
    },
  },
  methods: {
    ...mapActions(['updateField', 'resetBudget']),
    // Proxy to BudgetsForm so the dialog can gate Save / the Budget tab error state on
    // the budget validity (its fields live in BudgetsForm's nested observer).
    validate() {
      return this.$refs.budgetsForm?.validate?.() ?? true;
    },
    validateSilently() {
      return this.$refs.budgetsForm?.validateSilently?.() ?? true;
    },
    reset() {
      this.$refs.budgetsForm?.reset?.();
    },
    handleClearBudget() {
      this.resetBudget();
      this.$emit('clearedBudget');
    },
    handleChangeBudgetField(field, val) {
      this.updateField({ path: `budget.${field}`, value: val });
    },
  },
};
</script>
